<app-page-header [header]="'remote.verify.title'" />

<qbe-panel-component>
  <ng-container *ngIf="!(verifyOtpIsOk$ | async); else passwordOk">
    <div class="page-container" [ngSwitch]="sentSmsTokenState$ | async">
      <ng-container *ngSwitchCase="apiState.success">
        <div *ngIf="(isActive$ | async); else inactive" class="u-df-c page-content-container nx-margin-bottom-2m">
          <h2
            nxHeadline="section"
            class="u-text-center nx-margin-bottom-2m">
            {{ 'remote.verify.content.active.header' | translate }}
          </h2>
          <p
            nxCopytext="large"
            class="nx-margin-bottom-4m">
            {{ 'remote.verify.content.active.description' | translate:(params$ | async) }}
          </p>
          <form [formGroup]="formGroup" class="u-df-c">
            <nx-message *ngIf="smsTokenCounter > 1" context="info" class="nx-margin-bottom-4m">
              {{ 'remote.verify.content.active.otp_resent' | translate:(params$ | async)}}
            </nx-message>
            <nx-formfield [label]="'remote.verify.content.active.otp' | translate">
              <input
                required nxInput
                type="text"
                formControlName="otp"
                inputmode="numeric"
                autocomplete="one-time-code" />
            </nx-formfield>
            <nx-error *ngIf="errorDisplay$ | async" class="nx-margin-bottom-2m">
              {{ (errorMessage$ | async) || '' | translate }}
            </nx-error>
            <button
              nxButton class="u-mx-auto"
              (click)="verifyOtp()"
              [disabled]="(verifyOtpState$ | async) === apiState.pending"
              type="submit">
              {{ 'remote.verify.content.active.button_submit' | translate }}
            </button>
          </form>
        </div>
        <div *ngIf="(isActive$ | async)" class="u-text-center page-content-container">
          <h4 nxHeadline="subsection-xsmall" class="nx-margin-bottom-2xs">
            <b>
              {{ 'remote.verify.content.resend.header' | translate }}
            </b>
          </h4>
          <p nxCopytext="normal" class="nx-margin-bottom-2xs">
            {{ 'remote.verify.content.resend.description' | translate }}
          </p>
          <button
            nxButton="secondary"
            (click)="sendSmsToken()"
            [disabled]="isSendSmsTokenDisabled && smsTokenCounter > 1">
            {{ 'remote.verify.content.resend.button_resend' | translate }}
          </button>
        </div>
        <app-illustration-absolute name="clientAndAgentShakingHands" [maxWidth]="341" />
      </ng-container>
      <app-error *ngSwitchCase="apiState.error"  [appError]="sentSmsTokenError$ | async"/>
      <app-loader *ngSwitchDefault />
    </div>
  </ng-container>
</qbe-panel-component>

<ng-template #inactive>
  <div class="page-content-container">
    <nx-error class="nx-margin-bottom-m">
      {{ 'remote.verify.content.inactive.error' | translate }}
    </nx-error>
    <p nxCopytext="normal">
      {{ 'remote.verify.content.inactive.description' | translate:(params$|async) }} <br />
      <br />
      {{ 'remote.verify.content.inactive.name' | translate }} {{ agentName$ | async }}<br />
      {{ 'remote.verify.content.inactive.phone' | translate }} <a [href]="(agentPhone$ | async)?.link"
                                                                  class="md-link">{{ (agentPhone$ | async)?.text }}</a><br />
      {{ 'remote.verify.content.inactive.email' | translate }} <a [href]="(agentEmail$ | async)?.link"
                                                                  class="md-link">{{ (agentEmail$ | async)?.text }}</a>
    </p>
  </div>
</ng-template>

<ng-template #passwordOk>
  <app-loader />
</ng-template>
